export default __webpack_public_path__ + "static/expertise-3ad6992fb5b941ddd369339a38fa111f.webp";